export default "__VITE_ASSET__243fa83b__"